export default __webpack_public_path__ + "static/media/locations.9967ef8f.svg";